import { useEffect, useState } from 'react'
import Grid from '@config/Grid/Grid'
import { useTranslation } from 'react-i18next'
import Loader from '@/shared/components/Loader/Loader'
import styles from './LoadingPage.module.scss'

// Hearthstone-style loading tips, a random one is shown and rotates every few
// seconds while the app preloads. Keys live under LOADING.TIPS.* (en/pl).
const TIP_COUNT = 19
const TIP_INTERVAL_MS = 4000

const randomTip = () => Math.floor(Math.random() * TIP_COUNT)

// Renders a tip, highlighting *asterisk-wrapped* words in orange.
const renderTip = (text: string) =>
  text.split('*').map((segment, index) =>
    index % 2 === 1 ? (
      // eslint-disable-next-line react/no-array-index-key
      <mark key={index} className="mark-orange">
        {segment}
      </mark>
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <span key={index}>{segment}</span>
    )
  )

function LoadingPage() {
  const { t } = useTranslation()
  const [tipIndex, setTipIndex] = useState(randomTip)

  useEffect(() => {
    const id = setInterval(() => {
      // Pick a different tip than the current one so it always visibly changes.
      setTipIndex(prev => {
        const next = randomTip()
        return next === prev ? (next + 1) % TIP_COUNT : next
      })
    }, TIP_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  return (
    <Grid>
      <div className={`start-5 col-4 ${styles.loadingPageWrapper}`}>
        <div className={styles.loadingPageContainer}>
          <p className={`logo-font ${styles.sideBarLogo}`}>
            <mark className="mark-white">MENU</mark>
            <mark className="mark-orange">!</mark>
          </p>
          <Loader size="large" />
          <div className={styles.loadingPageTextContainer}>
            <p className={`body-bold-small ${styles.loadingText}`}>
              {t('LOADING.TEXT')}
            </p>
            {/* key forces a remount so the fade-in replays on every new tip */}
            <p
              key={tipIndex}
              className={`title-bold-large ${styles.loadingStatus} ${styles.loadingTip}`}
            >
              {renderTip(t(`LOADING.TIPS.${tipIndex}`))}
            </p>
          </div>
        </div>
      </div>
    </Grid>
  )
}
export default LoadingPage
